<h1 mat-dialog-title>Enable G2 review prompts</h1>

<div mat-dialog-content class="content">
    <ng-container *ngIf="!isDone">
        <form [formGroup]="form" class="celo-input-outline">
            <mat-form-field appearance="outline">
                <mat-label>User IDs, one per line</mat-label>
                <textarea matInput formControlName="userIds" rows="10"></textarea>
            </mat-form-field>
        </form>
        <div class="hint">{{ userIds.length }} unique user ID(s)</div>
        <div *ngIf="isSubmitting" class="hint">Batch {{ currentBatch }} of {{ totalBatches || '…' }}</div>
    </ng-container>

    <ng-container *ngIf="isDone">
        <div class="summary">
            <div>Enabled: {{ resultCounts.enabled }}</div>
            <div class="warning">Enabled, but prompted within the last year: {{ resultCounts.enabledButPromptedWithinYear }}</div>
            <div>Skipped, already reviewed: {{ resultCounts.skippedAlreadyReviewed }}</div>
            <div>Not found: {{ resultCounts.notFound }}</div>
            <div *ngIf="failedBatchCount" class="error">
                {{ failedBatchCount }} batch(es) failed ({{ failedUserIds.length }} user(s) not processed)
            </div>
        </div>

        <div *ngIf="flaggedResults.length" class="list">
            <div class="list-title">Needs attention</div>
            <div *ngFor="let item of flaggedResults" [ngClass]="{ warning: item.result === 'enabledButPromptedWithinYear' }">
                {{ item.userId }} - {{ item.result }}
            </div>
        </div>

        <div *ngIf="failedUserIds.length" class="list">
            <div class="list-title error">Failed (not processed)</div>
            <div *ngFor="let userId of failedUserIds">{{ userId }}</div>
        </div>
    </ng-container>
</div>

<div mat-dialog-actions class="actions">
    <ng-container *ngIf="!isDone">
        <button mat-button class="celo-secondary-button" (click)="close()" [disabled]="isSubmitting">Cancel</button>
        <button mat-button class="celo-primary-button" (click)="submit()" [disabled]="isSubmitting || !userIds.length">
            Enable
        </button>
    </ng-container>
    <button *ngIf="isDone" mat-button class="celo-primary-button" (click)="close()">Close</button>
</div>
